module.exports = __webpack_public_path__ + "static/media/menuBackgroundBlue.82cd650b.svg";